export default {"src":"/_next/static/media/circle.f50358a1.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};